import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface CreditTransaction {
    id: number;
    type: string;
    typeLabel: string;
    amount: number;
    description: string;
    entityId: number | null;
    entityType: string | null;
    status: string;
    statusLabel: string;
    createdAt: string;
    refundPercentage?: number;
}

export interface CreditBalanceResponse {
    balance: number;
    recentTransactions: CreditTransaction[];
}

export interface CreditTransactionsResponse {
    transactions: CreditTransaction[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export function useCredits() {
    return useQuery<CreditBalanceResponse>({
        queryKey: ['credits'],
        queryFn: () => api.get('/api/credits'),
        staleTime: 0,
    });
}

export function useCreditTransactions(page = 1, limit = 20, type?: string, search?: string) {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
    });

    if (type) {
        params.set('type', type);
    }

    if (search) {
        params.set('search', search);
    }

    return useQuery<CreditTransactionsResponse>({
        queryKey: ['credits', 'transactions', page, limit, type, search],
        queryFn: () => api.get(`/api/credits/transactions?${params}`),
        staleTime: 0,
        placeholderData: keepPreviousData,
    });
}
